var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center py-4"},[_c('h1',{staticClass:"text-3xl font-bold mb-2"},[_vm._v(" "+_vm._s(_vm.title))]),(_vm.description)?_c('h2',{staticClass:"text-md mb-4"},[_vm._v(" "+_vm._s(_vm.description))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }